<template>
  <div class="about">
    <h3>About the App</h3>
    <p>This application was at first made for a 20 minute challange from start to app</p>
    <p>The requirements were simple: Have at least 3 pages and have communication with a JSON REST API</p>
    <p>Later the app was updated to serve as an example of an application for displaying departure flights for students on Singidunum University</p>
    <p>Links to <a href="https://github.com/Pequla/flight-cache">Flight API</a> and <a href="https://github.com/Pequla/fly-vue">Source Code</a></p>
  </div>
</template>
